// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import getCascadedSegmentEndIds from './getCascadedSegmentEndIds'

/**
 * @typedef {Object} callsignCascadeAggregateGroup
 * @property {Array<number>} matchedSegmentEndIds - segment end ids which should be cascaded with the trigger segment end data
 * @property {number} triggeredSegmentEndId - segment end id that was updated and has triggered the callsign cascade.
 */

/**
 * makes a list of path ids based on the paths and which segment ends were specified in the callsign cascade data.
 * @param {Array<callsignCascadeAggregateGroup>} callsignCascadeData - this comes from Callsign Cascade redux form
 * @param {List<Set>} paths - either from bulk edit or project summary store
 * @returns {Array<number>} pathIds - an array of the reduced path ids.
 */

const getPathIdsToUpdate = (callsignCascadeData, paths) => {
  const cascadedSegmentEnds = getCascadedSegmentEndIds(callsignCascadeData)

  return (
    paths.reduce((a, d) => {
      const segmentEndId1 = d.getIn(['site1', 'segmentEndId'])
      const segmentEndId2 = d.getIn(['site2', 'segmentEndId'])

      if (
        cascadedSegmentEnds.includes(segmentEndId1) ||
        cascadedSegmentEnds.includes(segmentEndId2)
      ) {
        a.push(d.get('pathId'))
      }
      return a
    }, [])
  )
}

export default getPathIdsToUpdate
